// import _ from 'lodash';

class TextRotator {
    constructor(element, options = {}) {
        console.log('TextRotator constructor called with:', element, options);
        this.element = element;
        this.options = {
            texts: ['behaviourally intelligent'],
            interval: 5000, // 5 seconds
            animationDuration: 600,
            opacitySpeed: 0.4, // Multiplier for opacity animation speed (0.4 = 40% of animationDuration)
            translateDistance: 50, // Distance in pixels for text movement (reduced from 100% to prevent overlap)
            ...options
        };

        this.currentIndex = 0;
        this.isAnimating = false;

        if (this.element) {
            console.log('Initializing TextRotator...');
            this.init();
        }
    }

    init() {
        // Add text rotator class
        this.element.classList.add('text-rotator');

        // Set up the container styles
        this.element.style.position = 'relative';
        this.element.style.display = 'inline-block';
        // this.element.style.overflow = 'hidden';

        // Store original text as first option if not in texts array
        const originalText = this.element.textContent.trim();
        if (!this.options.texts.includes(originalText)) {
            this.options.texts[0] = originalText;
        }

        // Create text spans
        this.createTextSpans();

        // Start the rotation
        this.startRotation();
    }

    createTextSpans() {
        // Store the original styles to calculate width
        const originalDisplay = this.element.style.display;
        const originalPosition = this.element.style.position;

        // Temporarily reset to measure width
        this.element.style.display = 'inline-block';
        this.element.style.position = 'static';

        let maxWidth = 0;
        const tempSpans = [];

        // Create temporary spans to measure width
        this.options.texts.forEach((text) => {
            const tempSpan = document.createElement('span');
            tempSpan.textContent = text;
            tempSpan.style.visibility = 'hidden';
            tempSpan.style.position = 'absolute';
            tempSpan.style.whiteSpace = 'nowrap';
            this.element.appendChild(tempSpan);
            tempSpans.push(tempSpan);
            const width = tempSpan.offsetWidth;
            maxWidth = Math.max(maxWidth, width);
        });

        // Clean up temp spans
        tempSpans.forEach(span => span.remove());

        // Set container width to max width
        this.element.style.width = maxWidth + 'px';
        this.element.style.minWidth = maxWidth + 'px';

        // Restore original styles
        this.element.style.display = originalDisplay;
        this.element.style.position = originalPosition;

        // Clear and create actual spans
        this.element.innerHTML = '';

        this.options.texts.forEach((text, index) => {
            const spanContainer = document.createElement('div');
            spanContainer.className = 'text-rotator-container';
            spanContainer.style.position = 'absolute';
            spanContainer.style.top = '0';
            spanContainer.style.whiteSpace = 'nowrap';
            spanContainer.style.transition = `transform ${this.options.animationDuration}ms ease-in-out, opacity ${this.options.animationDuration * this.options.opacitySpeed}ms ease-in-out`;

            const span = document.createElement('span');
            span.textContent = text;
            span.style.position = 'relative';
            span.style.display = 'inline-block';

            spanContainer.appendChild(span);

            // Set initial position BEFORE adding to DOM to prevent flash
            if (index === 0) {
                spanContainer.style.transform = 'translateY(0)';
                spanContainer.style.opacity = '1';
            } else {
                spanContainer.style.transform = `translateY(${this.options.translateDistance}px)`;
                spanContainer.style.opacity = '0';
            }

            // Add to DOM
            this.element.appendChild(spanContainer);
        });

        this.textSpans = this.element.querySelectorAll('.text-rotator-container');
    }

    rotateText() {
        if (this.isAnimating) return;

        this.isAnimating = true;
        const currentContainer = this.textSpans[this.currentIndex];
        const nextIndex = (this.currentIndex + 1) % this.options.texts.length;
        const nextContainer = this.textSpans[nextIndex];

        // Animate current text out (up)
        currentContainer.style.transform = `translateY(-${this.options.translateDistance}px)`;
        currentContainer.style.opacity = '0';

        // Prepare next text (start from bottom)
        nextContainer.style.transform = `translateY(${this.options.translateDistance}px)`;
        nextContainer.style.opacity = '0';

        // Animate next text in (up to center)
        setTimeout(() => {
            nextContainer.style.transform = 'translateY(0)';
            nextContainer.style.opacity = '1';
        }, 50);

        // Update current index and reset animation flag
        setTimeout(() => {
            this.currentIndex = nextIndex;
            this.isAnimating = false;

            // Reset all other containers to bottom position
            this.textSpans.forEach((container, index) => {
                if (index !== this.currentIndex) {
                    container.style.transform = `translateY(${this.options.translateDistance}px)`;
                    container.style.opacity = '0';
                }
            });
        }, this.options.animationDuration);
    }

    startRotation() {
        this.interval = setInterval(() => {
            this.rotateText();
        }, this.options.interval);
    }

    stop() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    destroy() {
        this.stop();
        if (this.element) {
            this.element.style.position = '';
            this.element.style.display = '';
            this.element.style.overflow = '';
            this.element.innerHTML = this.options.texts[0];
        }
    }
}

function initTextRotators() {
    console.log('Initializing text rotators...');

    // Target the specific span with "businesses" text
    const rotatorElements = document.querySelectorAll('.b-hero p.c-carousel');
    console.log('Found .b-hero p .c-carousel elements:', rotatorElements.length);

    rotatorElements.forEach((element, index) => {
        console.log(`Element ${index}:`, element.textContent.trim());

        // Check if this element contains "businesses"
        if (element.textContent.trim() === 'businesses') {
            console.log('Creating text rotator for element:', element);
            new TextRotator(element, {
                texts: [
                    'businesses',
                    'conversations',
                    'menus',
                    'comms',
                    'products',
                    'packaging',
                    'interactions'
                ],
                interval: 2500,
                animationDuration: 300,
                opacitySpeed: 1,
                translateDistance: 40
            });
        }
    });
}

// Initialize text rotators
initTextRotators();

// Scroll indicator functionality
function initScrollIndicator() {
    const scrollIndicator = document.querySelector('.c-scroll-indicator');

    if (scrollIndicator) {
        scrollIndicator.addEventListener('click', (e) => {
            e.preventDefault();

            // Find the hero section
            const heroSection = scrollIndicator.closest('section');

            if (heroSection) {
                // Find the next section after hero
                const nextSection = heroSection.nextElementSibling;

                if (nextSection) {
                    // Smooth scroll to next section
                    nextSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        });
    }
}

// Initialize scroll indicator
initScrollIndicator();
